import { MiembroFamilia } from '../../../servicios/lugares.service';
import { ToastService } from '../../../servicios/toast.service';
import { LugaresService, Lugar } from 'src/app/servicios/lugares.service';
import { HeaderInfoService } from '../../../servicios/header-info.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-detalle-apartamento',
  templateUrl: './detalle-apartamento.component.html',
  styleUrls: ['./detalle-apartamento.component.scss']
})
export class DetalleApartamentoComponent implements OnInit {

  opciones: Array<string> = ["Titular", "Grupo familiar", "Inmueble"];
  actual: string = this.opciones[1];
  titularAsignado: boolean = false;
  grupoFamiliar: MiembroFamilia[];
  idInmueble: string;

  public titularForm: FormGroup = new FormGroup({
    nombreTitular: new FormControl(null),
    tipoDocumento: new FormControl(null),
    documento: new FormControl(null),
    indicativo: new FormControl("+57"),
    celular: new FormControl(null),
    estado: new FormControl(null),
  });

  public inmuebleForm: FormGroup;

  public inmuebleFormInitialValues;

  constructor(private headerInfoService: HeaderInfoService, private lugaresService: LugaresService, private toastService: ToastService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.titularForm.get("nombreTitular").value
    this.headerInfoService.cambiarTituloTarjeta("EDITAR INFORMACIÓN DE LOS RESIDENTES");
    this.headerInfoService.cambiarTextoTarjeta("Selecciona la opción que deseas editar, llena y/o edita la  información correspondiente a casa espacio.");
    this.headerInfoService.cambiarImagenTarjeta('./../../../../assets/header/editar-apartamento.svg');

    this.idInmueble = this.route.snapshot.paramMap.get("id");

    this.lugaresService.getLugar(this.idInmueble).subscribe(res => {
      let infoLugar: Lugar = res.data.data_lugar;

      this.titularAsignado = infoLugar.owner;

      this.inmuebleForm = new FormGroup({
        area: new FormControl(infoLugar.area_name),
        apartamento: new FormControl(infoLugar.local_number),
        costoAdministracion: new FormControl(infoLugar.admon_cost, [Validators.required]),
        estado: new FormControl(infoLugar.status)
      });

      this.inmuebleFormInitialValues = this.inmuebleForm.value;
      
      this.titularForm.get("nombreTitular").setValue(infoLugar.user_name);
      this.titularForm.get("tipoDocumento").setValue(infoLugar.user_type_document);
      this.titularForm.get("documento").setValue(infoLugar.user_number_document);

      if(!this.titularAsignado) {
        this.titularForm.get("indicativo").setValidators([Validators.required]);
        this.titularForm.get("indicativo").updateValueAndValidity();
        this.titularForm.get("celular").setValidators([Validators.required]);
        this.titularForm.get("celular").updateValueAndValidity();
      } else {
        this.titularForm.get("indicativo").setValue(infoLugar.indicativo);
        this.titularForm.get("celular").setValue(infoLugar.celular);
      }
    }, err => {
      this.toastService.mostrarToast(err.error.message);
    });

    this.lugaresService.traerGrupoFamiliar(this.idInmueble).subscribe(res => {
      this.grupoFamiliar = res.data.grupofamiliar;
    }, err => {
      this.toastService.mostrarToast(err.error.message);
    });
  }

  handleOpcion(opcion: string): void {
    this.actual = opcion;
  }

  get nombreTitular(): string {
    return this.titularForm.get("nombreTitular").value;
  }

  get tipoDocumento(): string {
    return this.titularForm.get("tipoDocumento").value;
  }

  get documento(): string {
    return this.titularForm.get("documento").value;
  }

  get indicativo(): string {
    return this.titularForm.get("indicativo").value;
  }

  get celular(): string {
    return this.titularForm.get("celular").value;
  }

  get area(): string {
    return this.inmuebleForm.get("area").value;
  }

  get apartamento(): string {
    return this.inmuebleForm.get("apartamento").value;
  }

  get costoAdministracion(): number {
    return this.inmuebleForm.get("costoAdministracion").value;
  }

  get estado(): number {
    return this.inmuebleForm.get("estado").value;
  }

  public eliminarTitular(): void {
    this.lugaresService.eliminarTitularInmueble(this.idInmueble).subscribe(res => {
      this.toastService.mostrarToast(res.data.message);
      this.titularAsignado = false;
      this.titularForm = new FormGroup({
        nombreTitular: new FormControl(null),
        tipoDocumento: new FormControl(null),
        documento: new FormControl(null),
        indicativo: new FormControl("+57"),
        celular: new FormControl(null),
        estado: new FormControl(null),
      });
    }, (err) => {
      this.toastService.mostrarToast(err.error.data.message);
    });
  }

  public agregarTitular(): void {
    if(this.titularForm.valid) {
      this.lugaresService.asignarTitularInmueble(this.idInmueble, this.indicativo, this.celular).subscribe(res => {
        this.toastService.mostrarToast(res.data.message);
        this.titularForm.get("indicativo").setValue(this.indicativo);
        this.titularForm.get("celular").setValue(this.celular);
        this.titularAsignado = true;
      }, (err) => {
        this.toastService.mostrarToast(err.error.data.message);
      });
    } else {
      this.toastService.mostrarToast("Por favor complete todos los campos");
    }
  }

  public actualizarInformacionInmueble() {
    if(this.inmuebleForm.valid) {
      this.lugaresService.actualizarInformacionInmueble(this.idInmueble, this.area, this.apartamento, this.costoAdministracion, this.estado).subscribe(res => {
        this.toastService.mostrarToast("Datos actualizados");

        this.inmuebleForm = new FormGroup({
          area: new FormControl(this.area, [Validators.required]),
          apartamento: new FormControl(this.apartamento, [Validators.required]),
          costoAdministracion: new FormControl(this.costoAdministracion, [Validators.required]),
          estado: new FormControl(this.estado)
        });

        this.inmuebleFormInitialValues = this.inmuebleForm.value;
      }, (err) => {
        this.toastService.mostrarToast(err.error.data.message);
      });
    } else {
      this.toastService.mostrarToast("Por favor complete todos los campos");
    }
  }
  
  public numSequence(n: number): Array<number> {
    return Array(n);
  }

  public cambiarInvitadosPermitidos(miembro: MiembroFamilia) {
    this.lugaresService.cambiarInvitadosPermitidosMiembroFamilia(this.idInmueble, miembro).subscribe(res => {
      this.toastService.mostrarToast("Permiso de invitados actualizado");

      this.grupoFamiliar = this.grupoFamiliar.map(miembroFamilia => {
        if(miembroFamilia.id === miembro.id) {
          return {
            ...miembroFamilia,
            guests_allowed: parseInt(res.data.lugar.guests_allowed)
          }
        } else {
          return miembroFamilia;
        }
      })

    }, (err) => {
      this.toastService.mostrarToast(err.error.data.message);
    });
  }

  public cambiarEstado(estado: number) {
    this.inmuebleForm.get("estado").setValue(estado);
  }
}
